import React from 'react';

interface GridModeToggleIconProps {
  fillColor?: string;
}

const GridModeToggleIcon = (props: GridModeToggleIconProps) => {
  const fillColor = props?.fillColor || '#000000';

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="8" height="8" rx="2.25" fill={fillColor} />
      <rect y="10" width="8" height="8" rx="2.25" fill={fillColor} />
      <rect x="10" width="8" height="8" rx="2.25" fill={fillColor} />
      <rect x="10" y="10" width="8" height="8" rx="2.25" fill={fillColor} />
    </svg>
  );
};

export default GridModeToggleIcon;
